import { render, staticRenderFns } from "./ForgottenPasswordComponent.vue?vue&type=template&id=3eadf33b&scoped=true&"
import script from "./ForgottenPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPasswordComponent.vue?vue&type=style&index=0&id=3eadf33b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eadf33b",
  null
  
)

export default component.exports